$.fn.wipProduct = function(settings){
	return;
	$('.product-single').css('display','flex');
	 $(".stick").stick_in_parent({offset_top: 95});
	 console.log('are we sticking');
}

$.fn.wipCollection = function(settings){
	// private variables
	var body, nextLink, timeout, paginationLocation, end;

		body = $(this),
		paginationLocation = $('.pagination'),
		end = false,
		timeout = true, 
		nextLink = $('.pagination .page.current').next().find("a").attr('href');

	// private functions
	var ajaxCall, ajaxSuccess, scrolledIntoView, imageAppear;

	scrolledIntoView = function(elem){
	    var docViewTop = $(window).scrollTop();
	    var docViewBottom = docViewTop + $(window).height();

	    var elemTop = $(elem).offset().top - 400;
	    var elemBottom = elemTop + $(elem).height();

	    return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
	}
	imageAppear = function(imgs){
			imgs.each(function(index){
				var newD = index * 300;
				setTimeout(function(){
					imgs.velocity({ opacity: 1}, 600);	
				}, newD);
			});
	}
	ajaxSuccess = function(html){
		var source = $(html),
			sourceBody = source.find('.collectionbody').children(),
			newSource = source.find('.pagination .page.current').next().find("a"),
			lazyElements = source.find('.lazyload');

			if(newSource.length > 0){
				newSource = newSource.attr('href');
			}else{
				end = true;
				$(window).unbind('scroll');
			}

			sourceBody.appendTo(body);
			nextLink = newSource;
			imageAppear(lazyElements);
      $(".carousel:not('.slick-initialized')").slick({
      dots: false,
      infinite: true,
      autoplay: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      rtl: true,
      nextArrow: '<i class="fa fa-angle-left fa-4x"></i>',
      prevArrow: '<i class="fa fa-angle-right fa-4x"></i>',
    });
      
	}
	ajaxCall = function(url){
		console.log('fetching', url);
		console.log(end);
			$.ajax({
				url: url,
				dataType: "html",
				success: function(html){
					ajaxSuccess(html);
				},
				error: function(e){
					console.log(e);
				}	
			});
	}
	$(window).on("scroll",function(){
		if(scrolledIntoView(paginationLocation) && timeout){
				timeout = false;
				ajaxCall(nextLink);
				setTimeout(function(){
					timeout = true;
				}, 500);
		}
	});
}


// General load function (Universal)
$(window).on("load", function(){
	var searchIcon, $searchOverlay, searchOpen, searchOverlayCreate, searchForm, searchInput, searchSubmit, imgs;
		imgs = $(".lazyload");
    const isCollection = document.body.classList.contains('template-collection');


	console.warn('WINDOW ON LOAD', imgs);
	imgs.each(function(index){
		var thated = $(this);
		let gridItem = thated.closest('.collection-product-ind');
		let delayIndex = (gridItem) ? $(gridItem).index() : index;
		var delay = delayIndex * 400;
		let isSlickSlide = thated.parent().parent().is('.slick-slide');
      
        if(isCollection) {
           thated.css('opacity', 1); 
        } else {
          setTimeout(function() {
              thated.velocity({ opacity: 1 }, 600);
          }, delay);
        }
		
	});

	// Building Search Functionality
	searchIcon = $('.searchcontainer');
	searchOverlayCreate = $("<div>", { class: 'search_overlay'});
	searchOpen = false;
	searchForm = $("<form>", { class: "search windowsearch", action: "/search" });
	searchInput = $("<input>", { type: "text", placeholder: "Search", name:"q", class:"searchfield" });
	searchSubmit = $("<input>", { type: "submit", value: "Search"});

	searchForm.append(searchInput, searchSubmit);
	searchOverlayCreate.append(searchForm);
	searchOverlayCreate.appendTo($("body"));
	$searchOverlay = $('.search_overlay');
	searchIcon.on("click",function(){
		$searchOverlay.addClass('display');
		$searchOverlay.find('.searchfield').focus();
		searchOpen = true;
	});

	// listen for esc while search window is open
	$(document).keyup(function(e){
		if( e.keyCode === 27 && searchOpen ){
			$searchOverlay.removeClass('display');
			searchOpen = false;
		}
	});

	// listen for click of parent but exclude form
	$searchOverlay.on("click",function(e){
		if($(e.target).is('.search_overlay')){
			$(this).removeClass('display');
			searchOpen = false;
		}else{

		}
	});
});






